import React from 'react';

export const multiPathRoutes = ({path, ...restProps}) => {
  return path.map(p => ({path: p, ...restProps}));
};

export const notFoundRoute = {
  path: '*',
  element: <div />
};
